import React, { createContext, useContext } from "react";

export const CMIContext = createContext({
  openAI: () => {},
  refreshing: false,
  onRefresh: () => {},
});

export const useCMI = () => useContext(CMIContext);
